import React, { Component } from 'react';
import Input from '../Common/Forms/Input';
import { Link } from 'react-router-dom';
import {
  signInWithEmailAndPassword,
  signOut,
  getCurrentUser,
  sendPasswordResetMail,
  sendEmailVerification,
  getData,
  saveDeviceTokens,
  getDataOnce,
  twoFactorAuthentication,
  captchaVerifier,
  signInWithEmailAndPasswordForAdmin,
  patientVerificationMailResent,
} from '../../store/actions';
import { validateEmail } from '../../utils/helperFunctions';
import responseMessages from '../../response.json';
import Loader from '../Loader';
import Cookies from 'universal-cookie';
import { getToken } from '../../firebaseMessage';
import renderHTML from 'react-render-html';
import { firestoreOperationsDb, masterDb } from '../../firebase';
import { handleValidation } from '../../utils/validation';
import {
  fetchAuthCredentials,
  getVerifyGoogleCredentials,
} from '../../APIs/Authentication';
import AdminAuthenticator from '../Auth';
import { loggerHandleFunction } from '../../utils/loggerHandleFunction';
import SubscriptionPlan from '../Subscriptionplan';
const cookie = new Cookies();

class Login extends Component {
  constructor(props) {
    // console.log('Props', props);
    super(props);
    this.state = {
      isLoading: false,
      isAdminAuthRoute: props.isAdminAuthRoute,
      forgotEmail: '',
      email: '',
      password: '',
      phoneNumber: null,
      errorMessage: '',
      isFormValid: false,
      resetVerificationEmail: '',
      isForgotFormValid: false,
      phoneNumberFocused: false,
      resetEmailName: '',
      showPassword: false,
      resendCodeModal: false,
      planModal: false,
      resetPasswordModal: false,
      sendVerificationModel: false,
      resetStep2: false,
      resendLink: false,
      isAdminLoader: false,
      subscriptionPlanModal: false,
      otp: '',
      err: {
        email: '',
        password: '',
      },
      errors: {
        password: '',
        confirmPassword: '',
        phoneNumber: '',
      },
      emailNotVerified: false,
      isQrVisible: false,
      adminData: [],
    };
    this.validateForm = this.validateForm.bind(this);
    this.validateForgotForm = this.validateForgotForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleGoogleAuthForAdmin = this.handleGoogleAuthForAdmin.bind(this);
    this.sendVerificationEmail = this.sendVerificationEmail.bind(this);
    this.sendResetMail = this.sendResetMail.bind(this);
    this.handleVerificationAdmin = this.handleVerificationAdmin.bind(this);
    this.handleSubmitPhoneNumber = this.handleSubmitPhoneNumber.bind(this);
    this.handleSubmitOTP = this.handleSubmitOTP.bind(this);
  }

  validateForm = () => {
    let { email, password } = this.state;

    if (password && validateEmail(email)) {
      this.setState({
        isFormValid: true,
      });
    } else {
      this.setState({
        isFormValid: false,
      });
    }
  };

  validateForgotForm = () => {
    let { forgotEmail } = this.state;

    if (forgotEmail && validateEmail(forgotEmail)) {
      this.setState({
        isForgotFormValid: true,
      });
    } else {
      this.setState({
        isForgotFormValid: false,
      });
    }
  };

  handleChange(event) {
    const { value, name, type, checked } = event.target;
    const formValue = type === 'checkbox' ? checked : value;
    this.setState({
      ...this.state,
      [name]: formValue,
      errorValidateMessage: {
        ...this.state.errorValidateMessage,
        [name]: handleValidation(name, formValue),
      },
    });
  }

  showHidePassword(stateToUpdate, e) {
    e.preventDefault();
    this.setState({
      [stateToUpdate]: !this.state[stateToUpdate],
    });
  }

  handleSubmitPhoneNumber = async (number) => {
    captchaVerifier('sign-in-button', this.handleSubmitPhoneNumber);
    const phoneNumber = String(this.state.phoneNumber || number);
    const appVerifier = window.recaptchaVerifier;
    const isOtpSent = await twoFactorAuthentication(phoneNumber, appVerifier);
    return isOtpSent;
  };

  handleGoogleAuthForAdmin = async (
    email,
    userObj,
    domain = 'Nomadic Care'
  ) => {
    try {
      let AdminData = [];
      let filteredAdmin = [];
      this.setState({ isLoading: true });
      const response = await fetchAuthCredentials(email, domain);
      let image = await localStorage.getItem('QR_Image');
      console.log('UserObject', userObj);
      const userRef = await masterDb.collection('qrCode');
      await userRef
        .get()
        .then((doc) => {
          if (doc.size) {
            doc.forEach((value) => {
              let { adminId, formatedKey, qrImage, isScanned } = value.data();
              AdminData.push({
                adminId,
                formatedKey,
                qrImage,
                isScanned,
              });
              // console.log(adminId, formatedKey, qrImage);
              // if (adminId == userObj?.uid) {
              //   console.log("matched");
              //   this.setState({
              //     ...this.state,
              //     isMFAisAcrive: true,
              //     MFAsourceCode: qrImage,
              //     userObj,
              //     isLoading: false,
              //     formattedKey: formatedKey,
              //     isQrVisible: false
              //   });
              // }
              // else {
              //   if (response?.data) {
              //     const { qrCode, formattedKey } = response?.data?.data;
              //     console.log("qrcode", qrCode);
              //     this.setState({
              //       ...this.state,
              //       isMFAisAcrive: true,
              //       MFAsourceCode: qrCode,
              //       userObj,
              //       isLoading: false,
              //       formattedKey,
              //       isQrVisible: true
              //     });
              //     userRef.add({
              //       adminId: userObj?.uid,
              //       formatedKey: formattedKey,
              //       qrImage: qrCode
              //     }).then((data) => {
              //       console.log("daat added ", data
              //       );
              //     })
              //   }
              // }
            });
          }
        })
        .catch((error) => {
          console.log('Error', error);
        });

      filteredAdmin = await AdminData.filter(
        (item) => item.adminId == userObj.uid
      );

      if (filteredAdmin.length > 0) {
        console.log('matched');
        // let { adminId, formatedKey, qrImage } = value.data();
        filteredAdmin.map((data) => {
          this.setState({
            ...this.state,
            isMFAisAcrive: true,
            MFAsourceCode: data.qrImage,
            userObj,
            isLoading: false,
            formattedKey: data.formatedKey,
            isQrVisible: data.isScanned ? false : true,
          });
        });
      } else {
        if (response?.data) {
          const { qrCode, formattedKey } = response?.data?.data;
          console.log('qrcode', qrCode);
          this.setState({
            ...this.state,
            isMFAisAcrive: true,
            MFAsourceCode: qrCode,
            userObj,
            isLoading: false,
            formattedKey,
            isQrVisible: true,
          });
          userRef
            .add({
              adminId: userObj?.uid,
              formatedKey: formattedKey,
              qrImage: qrCode,
              isScanned: false,
            })
            .then((data) => {
              console.log('daat added ', data);
            });
        }
      }

      // console.log("Admin Data", );

      // if (image) {
      //   // this.setState({
      //   //   ...this.state,
      //   //   isMFAisAcrive: true,
      //   //   MFAsourceCode: JSON.parse(image).qrImage,
      //   //   userObj,
      //   //   isLoading: false,
      //   //   formattedKey: JSON.parse(image).formatkey,
      //   // });
      // } else {
      //   // if (response?.data) {
      //   //   const { qrCode, formattedKey } = response?.data?.data;
      //   //   console.log("qrcode", qrCode);
      //   //   this.setState({
      //   //     ...this.state,
      //   //     isMFAisAcrive: true,
      //   //     MFAsourceCode: qrCode,
      //   //     userObj,
      //   //     isLoading: false,
      //   //     formattedKey,
      //   //   });
      //   //   let obj = {
      //   //     qrImage: qrCode,
      //   //     formatkey: formattedKey
      //   //   }
      //   //   // await localStorage.setItem('QR_Image', JSON.stringify(obj));
      //   // }
      // }
    } catch (error) {
      console.log('error', error);
      this.setState({
        ...this.state,
        isMFAisAcrive: false,
        MFAsourceCode: null,
        formattedKey: null,
        isLoading: false,
      });
    }
  };

  // handleVerificationAdmin = async ({ email, password }) => {
  //   this.setState({ ...this.state, errorMessage: null });
  //   let userObj = {};
  //   try {
  //     this.setState({ isLoading: true });
  //     const userRef = await masterDb.collection("superAdmin");
  //     await userRef
  //       .where("email", "==", email)
  //       .where("password", "==", password)
  //       .get()
  //       .then((doc) => {
  //         if (doc.size) {
  //           doc.forEach((value) => {
  //             const user = value.data();
  //             userObj = { ...user };
  //           });
  //           this.setState({
  //             ...this.state,
  //             isLoading: false,
  //             errorMessage: null,
  //           });
  //           if (Object.values(userObj).length) {
  //             const { uid, email } = userObj;
  //             !!uid && !!email && this.handleGoogleAuthForAdmin(email, userObj);
  //           }
  //         } else {
  //           this.setState({
  //             ...this.state,
  //             isLoading: false,
  //             errorMessage: "Login credential is invalid.",
  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         loggerHandleFunction(err?.message || "Somthing went wrong.");
  //         console.log("err", err);
  //       });
  //     //   const response = await signInWithEmailAndPasswordForAdmin(email, password)
  //     //   if (response) {
  //     //     const { uid } = response
  //     //     console.log('uid1', uid)
  //     //     const userRef = await masterDb.collection("superAdmin");
  //     //     const data = await userRef.where("email", "==", email).where('uid', '==', uid).get()
  //     //     if (data.size) {
  //     //       let userObj = {}
  //     //       data.forEach(value => {
  //     //         const user = value.data()
  //     //         userObj = { ...user }
  //     //       })
  //     //       if (Object.values(userObj).length) {
  //     //         const { phoneNumber } = userObj
  //     //         console.log('phoneNumber', userObj)
  //     //         if(phoneNumber){
  //     //           const isOtpSent = await this.handleSubmitPhoneNumber(phoneNumber)
  //     //           console.log('isOtpSent', isOtpSent)
  //     //           this.setState({
  //     //             ...this.state, isLoading: false, openPhoneOTPModal: (!!phoneNumber && isOtpSent), openPhoneNumberModal: !phoneNumber
  //     //           })
  //     //         }else {
  //     //           this.setState({
  //     //             ...this.state, isLoading: false, openPhoneOTPModal: false, openPhoneNumberModal: true
  //     //           })
  //     //         }
  //     //       } else {
  //     //         this.setState({
  //     //           ...this.state,
  //     //           isLoading: false,
  //     //           errorMessage: "Invalid email or password."
  //     //         })
  //     //       }
  //     //     } else {
  //     //       this.setState({
  //     //         ...this.state,
  //     //         isLoading: false,
  //     //         errorMessage: "Invalid email or password."
  //     //       })
  //     //     }
  //     //   } else {
  //     //     this.setState({
  //     //       ...this.state,
  //     //       isLoading: false,
  //     //       errorMessage: "User not found"
  //     //     })
  //     //   }
  //   } catch (error) {
  //     this.setState({
  //       ...this.state,
  //       isLoading: false,
  //       errorMessage: error.message || "User not found",
  //     });
  //   }
  // };

  handleVerificationAdmin = async ({ email, password }) => {
    this.setState({});
    await signInWithEmailAndPasswordForAdmin(
      email,
      password,
      async (error, res) => {
        if (error) {
          console.log('Eroror in admin Login');
          this.setState({
            ...this.state,
            isLoading: false,
            errorMessage: 'Login credential is invalid.',
          });
          return;
        }
        if (res) {
          console.log('res', res);
          let newObj = {
            email: res?.user?.email,
            isAdmin: true,
            name: '',
            role: 'admin',
            uid: res?.user?.uid,
          };
          this.handleGoogleAuthForAdmin(res?.user?.email, newObj);
        }
      }
    );
  };
  handleVelidateAuthSecret = async (otp, formattedKey, userObj) => {
    try {
      this.setState({ isAdminLoader: true });
      const response = await getVerifyGoogleCredentials(otp, formattedKey);
      if (response) {
        const { data } = response;
        console.log("------------user -", data)
        this.setState({
          ...this.state,
          isAdminLoader: false,
          errorValidateMessage: {
            otp:
              data?.data === null
                ? 'Invalid Google Authenticator Code , Please check you have entered the code from the correct entry in your Authenticator app, or contact the admin.'
                : data?.data?.delta === -1
                  ? 'Invalid Google Authenticator Code, Please check you have entered the code from the correct entry in your Authenticator app, or contact the admin.'
                  : null,
          },
        });
        if (data?.data && data?.data?.delta === 0) {
          const { uid, name, isAdmin, role } = userObj;
          this.setState({ isAdminLoader: false });
          localStorage.setItem(
            'user',
            JSON.stringify({
              user_id: uid,
              name,
              email: this.state.email,
              isAdmin,
              role,
            })
          );
          console.log('user uid>>>>>>>>>.', uid)
          const qrCodeRef = masterDb.collection('qrCode');
          const snapshot = await qrCodeRef.where('adminId', '==', uid).get();

          if (!snapshot.empty) {
            const batch = masterDb.batch();  // Initialize a batch for updating multiple docs

            snapshot.forEach((doc) => {
              // Update the 'isScanned' field to true
              batch.update(doc.ref, { isScanned: true });
            });

            await batch.commit();  // Commit the batch update
            console.log(`Updated ${snapshot.size} document(s) where adminId is ${uid}`);
          } else {
            console.log('No documents found for the given UID');
          }





          window.location.reload();
        }
      }
    } catch (error) {
      console.log("errror fro catcg", error)
      this.setState({
        ...this.state,
        isLoading: false,
        isAdminLoader: false,
        errorMessage: error.message || 'User not found',
      });
    }
  };

  handleSubmitOTP = async (event) => {
    event.preventDefault();
    let errorObj = {};
    const { otp, userObj, formattedKey } = this.state;
    Object.keys({ otp }).forEach((val) => {
      const error = handleValidation(val, this.state[val]);
      if (error) {
        errorObj[val] = error;
      }
    });
    if (Object.keys(errorObj).length) {
      this.setState({
        ...this.state,
        errorValidateMessage: errorObj,
        errorMessage: null,
      });
      return;
    }

    await this.handleVelidateAuthSecret(otp, formattedKey, userObj);
    console.log('user Object,sasasasasa', userObj);
  };

  submitForm = async (event) => {
    event.preventDefault();
    let errorObj = {};
    const { email, password } = this.state;
    Object.keys({ email, password }).forEach((val) => {
      const error = handleValidation(val, this.state[val]);
      if (error) {
        errorObj[val] = error;
      }
    });
    if (Object.keys(errorObj).length) {
      this.setState({
        ...this.state,
        errorValidateMessage: errorObj,
        errorMessage: null,
      });
      return;
    }
    if (!this.props.isAdminAuthRoute) {
      this.setState({
        ...this.state,
        isLoading: true,
      });
      await signInWithEmailAndPassword(email, password, async (err, res) => {
        if (err) {
          console.log(
            '🚀 ~ Login ~ awaitsignInWithEmailAndPassword ~ err:',
            err
          );
          let message = err ? err : responseMessages.DB_ERROR;
          this.setState({
            // email: "",
            password: '',
            isFormValid: false,
            isLoading: false,
            errorMessage: message ? 'Login credential is invalid.' : '',
          });
        } else {
          let user = res;
          console.log('res -------', res);

          if (user.user.emailVerified === false) {
            console.log('user ---email ', user.user);
            this.setState({
              password: '',
              isFormValid: '',
              emailNotVerified: true,
              isLoading: false,
            });
            return;
            // signOut();
          } else {
            try {
              let token = await getToken();
              if (token) {
                await saveDeviceTokens(
                  user.user.uid,
                  token,
                  'add',
                  (err, res) => {
                    if (!err) {
                      localStorage.setItem('token', token);
                      cookie.set('deviceToken', token || {}, { path: '/' });
                    }
                  }
                );
              } else {
                console.log('No device Token found');
                // add alert for notification permissions
              }
            } catch (notiError) {
              console.log('Error getting Notification error', notiError);
              this.setState({
                ...this.state,
                isLoading: false,
              });
            }

            console.log('user--------', user.user.uid);
            await getData('users', user.user.uid, async (err, userRes) => {
              debugger
              console.log('🚀 ~ Login ~ awaitgetData ~ userRes:', userRes);
              if (err) {
                console.log('🚀 ~ Login ~ awaitgetData ~ err:', err);
                signOut();
                let message = err ? err : responseMessages.DB_ERROR;
                this.setState(
                  {
                    email: '',
                    password: '',
                    isFormValid: false,
                    isLoading: false,
                  },
                  () => {
                    console.log('error while get data', message);
                    loggerHandleFunction(message);
                  }
                );
              } else {
                await getData(
                  'clinics',
                  userRes.clinicId,
                  async (err, clinicRes) => {
                    if (err) {
                      signOut();
                      let message = err ? err : responseMessages.DB_ERROR;
                      this.setState(
                        {
                          email: '',
                          password: '',
                          isFormValid: false,
                          isLoading: false,
                        },
                        () => {
                          loggerHandleFunction(message);
                        }
                      );
                    }
                    clinicRes.clinicId = userRes.clinicId;
                    delete userRes.tokens;
                    await cookie.set('user', userRes || {}, { path: '/' });
                    await cookie.set('clinic', clinicRes || {}, { path: '/' });
                    console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
                    debugger
                    if (userRes.isProfileSet) {
                      if(!userRes.isFirstLoginCompleteAfterVerification) {
                          this.setState({
                            ...this.state,
                            isLoading: false,
                            subscriptionPlanModal: true,
                          });

                          console.log('This is the user’s first login after email verification!');
                          // Update Firestore to mark first login as complete
                          await firestoreOperationsDb.collection('users').doc(user.user.uid).set(
                            { isFirstLoginCompleteAfterVerification: true },
                            { merge: true }
                          );
                      } else {
                        if(!userRes.isFirstLoginComplete) {
                          await firestoreOperationsDb.collection('users').doc(user.user.uid).set(
                            { isFirstLoginComplete: true },
                            { merge: true }
                          );
                        }

                        window.location.href = this.props.isAdminAuthRoute
                            ? '/admin/dashboard'
                            : '/dashboard';
                        
                        // this.props.history.push(
                        //   this.props.isAdminAuthRoute
                        //     ? '/admin/dashboard'
                        //     : '/dashboard'
                        // );
                        // window.location.reload();
                      }
                    } else {
                      // this.props.history.push(`/profile/${userRes.userId}`);
                      // window.location.reload();
                      window.location.href = `/profile/${userRes.userId}`;
                    }
                  }
                );
              }
            });
          }
        }
      });
    } else if (this.props.isAdminAuthRoute) {
      await this.handleVerificationAdmin({ email, password });
      return;
    }
  };

  async sendVerificationEmail() {
    this.setState({ isLoading: true });
    let user = getCurrentUser();
    await getDataOnce('users', user.uid, async (error, userRes) => {
      if (error) {
        let message =
          error && error.message ? error.message : responseMessages.DB_ERROR;
        loggerHandleFunction(message);
        this.setState({ isLoading: false });
      }

      await getDataOnce('clinics', userRes.clinicId, async (err, clinicRes) => {
        if (err) {
          let message =
            error && error.message ? error.message : responseMessages.DB_ERROR;
          loggerHandleFunction(message);
          this.setState({ isLoading: false });
        }
        await sendEmailVerification(
          userRes.email,
          `${userRes.firstName} ${userRes.lastName}`,
          `${clinicRes.clinicName}`,
          (error, success) => {
            if (error) {
              let message =
                error && error.message
                  ? error.message
                  : responseMessages.DB_ERROR;
              this.setState({ isLoading: false });
              loggerHandleFunction(message);
            } else if (success.success) {
              this.setState({ isLoading: false, emailNotVerified: false });

              let message = responseMessages.LINK_SEND_SUCCESS;
              loggerHandleFunction(message);
            } else {
              let message =
                success && success.data
                  ? success.data
                  : responseMessages.DB_ERROR;
              this.setState({ isLoading: false });
              loggerHandleFunction(message);
            }
          }
        );
        this.setState({
          // email: "",
          password: '',
          isFormValid: false,
          // resendLink: false,
        });
      });
    });
  }

  async sendResetMail() {
    debugger
    let { forgotEmail } = this.state;
    try {
      let errorObj = {};
      Object.keys({ forgotEmail }).forEach((val) => {
        const error = handleValidation(val, this.state[val]);
        if (error) {
          errorObj[val] = error;
        }
      });
      if (Object.keys(errorObj)?.length) {
        this.setState({
          ...this.state,
          errorValidateMessage: errorObj,
          errorMessage: null,
        });
        return;
      }
      this.setState({ ...this.state, isLoading: true });
      debugger
      let isAdminRoute =
        this.state.isAdminAuthRoute || this.props.isAdminAuthRoute
          ? true
          : false;
      console.log(
        'isADmin routr',
        isAdminRoute,
        this.state.isAdminAuthRoute,
        this.props.isAdminAuthRoute
      );
      const response = await sendPasswordResetMail(forgotEmail, isAdminRoute);
      if (response) {
        const { type, response: data, message } = response;
        this.setState({
          ...this.state,
          resetPasswordModal: true,
          resetStep2: type !== 'error',
          isForgotFormValid: false,
          data,
          errorValidateMessage: {
            ...this.state.errorValidateMessage,
            forgotEmail: message,
          },
          isLoading: false,
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  resentEmailVerificationEMail = () => {
    console.log(
      this.state.resetVerificationEmail,
      'reset mail verifcation test'
    );
    patientVerificationMailResent({
      email: this.state.resetVerificationEmail,
      link: `${window.location.origin}/login`,
      name: this.state.resetEmailName,
    })
      .then((response) => {
        console.log(
          '🚀 ~ Login ~ clinicVerificationMailResent ~ respone:',
          response
        );
        if (response.success === true) {
          loggerHandleFunction('Mail sent on mentioned Email ');
        }
        if (response.success === false) {
          throw new Error(response.data);
        }
      })
      .catch((error) => {
        console.log(
          '🚀 ~ Login ~ clinicVerificationMailResent ~ error:',
          error
        );
        loggerHandleFunction(error);
      });
  };

  renderErrorMessage(type) {
    let { errors } = this.state;
    if (errors[type]) {
      return renderHTML(
        `<div className="error-wrapper"><p className="error-message">${errors[type]}</p></div>`
      );
    }
    return '';
  }

  render() {
    let {
      showPassword,
      email,
      forgotEmail,
      password,
      resendCodeModal,
      planModal,
      resetPasswordModal,
      resendLink,
      resetStep2,
      isMFAisAcrive,
      emailNotVerified,
      resetVerificationEmail,
      MFAsourceCode,
      resetEmailName,
      subscriptionPlanModal
    } = this.state;

    // console.log("errors", this.state);

    return (
      <div className="front-wrapper">
        {this.state.isLoading ? (
          <div className="custm-loader">
            <Loader></Loader>
          </div>
        ) : null}
        <div className="front-left">
          <div className="log-logo">
            <a href="#">
              <img
                src="/assets/img/logo_full.png"
                alt="logo"
                className="img img-fluid"
              />
            </a>
          </div>
          {isMFAisAcrive ? (
            <AdminAuthenticator
              {...{
                isLoading: this.state.isAdminLoader,
                isMFAisAcrive,
                MFAsourceCode,
                errorValidateMessage: this.state.errorValidateMessage,
                otp: this.state.otp,
                isQrVisible: this.state.isQrVisible,
                email: this.state.email,
              }}
              handleChange={this.handleChange}
              handleSubmitOtp={this.handleSubmitOTP}
            />
          ) : (
            <>
              <div className="log-header header-part-pd">
                <h1>Plan, track & collaborate.</h1>
                <h3>Improving patient outcomes.</h3>
                {this.state.isAdminAuthRoute || this.props.isAdminAuthRoute ? (
                  <h4 className="admin_header">Admin Login</h4>
                ) : null}
              </div>
              <div className="log-form new-form-pd">
                {/* {resendLink ? ( */}
                {/* <p className="dnthaveacc header-part-pd">
                Email Not verified?{" "}
                <a onClick={this.sendVerificationEmail}>
                  Resend Verification Link!
                </a>
              </p> */}
                <div
                  className={`common-popup reset-password popup-common-class fade ${resendLink ? 'show' : ''
                    }`}
                >
                  <div className="common-popup-outer">
                    <div className="common-popup-inner">
                      <div className="common-popup-box animate-box">
                        <div className="common-popup-innersec">
                          <div className="reset-password-form">
                            <div className="reset-email-sec reset-email-block">
                              <p>
                                {/* The account {email} has not been verified. We
                                have sent a verification link - please check
                                your email. */}
                                Enter your register email for get verification
                                email.
                              </p>
                              <div className="reset-form">
                                <div className="form-group">
                                  <div className="col-lg-12">
                                    <Input
                                      title="Your Name*"
                                      type="text"
                                      className="form-control custom-input"
                                      placeholder="Your  Name*"
                                      name="name"
                                      value={resetEmailName}
                                      onChange={(e) =>
                                        this.setState({
                                          resetEmailName: e.target.value,
                                        })
                                      }
                                    />
                                    <span className="error-message-text">
                                      {
                                        this.state.errorValidateMessage?.[
                                        'email'
                                        ]
                                      }
                                    </span>
                                  </div>
                                  <div className="col-lg-12">
                                    <Input
                                      title="Email Address*"
                                      type="email"
                                      className="form-control custom-input"
                                      placeholder="Email Address*"
                                      name="email"
                                      value={resetVerificationEmail}
                                      onChange={(e) =>
                                        this.setState({
                                          resetVerificationEmail:
                                            e.target.value,
                                        })
                                      }
                                    />
                                    <span className="error-message-text">
                                      {
                                        this.state.errorValidateMessage?.[
                                        'email'
                                        ]
                                      }
                                    </span>
                                  </div>
                                  <button
                                    className="log-btn step-btn reset-step2"
                                    onClick={() => {
                                      this.resentEmailVerificationEMail();
                                      this.setState({
                                        resendLink: false,
                                        resetVerificationEmail: '',
                                        resetEmailName: '',
                                      });
                                    }}
                                  >
                                    Send
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`common-popup reset-password popup-common-class fade ${emailNotVerified ? 'show' : ''
                    }`}
                >
                  <div className="common-popup-outer">
                    <div className="common-popup-inner">
                      <div className="common-popup-box animate-box">
                        <div className="common-popup-innersec">
                          <div className="reset-password-form">
                            <div className="reset-email-sec reset-email-block">
                              <p>
                                The account {email} has not been verified.
                                Please check your email for the verification
                                email, and click the link.
                                <br />
                                Would you like us to re-send this verification
                                email?"
                              </p>
                              <div className="reset-form">
                                <div className="form-group">
                                  <div className="update-patient-btns">
                                    <button
                                      // className="log-btn step-btn add-care-task pull-right"
                                      className="btn blue-light-transparent delete-patient-btn"
                                      onClick={() => {
                                        this.setState({
                                          emailNotVerified: false,
                                          email: '',
                                        });
                                      }}
                                    >
                                      Back
                                    </button>
                                    <button
                                      className="log-btn step-btn add-care-task pull-right"
                                      // className="btn blue-light-transparent delete-patient-btn"
                                      onClick={() => {
                                        this.sendVerificationEmail();
                                      }}
                                    >
                                      Resend
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ) : (
              ""
            )} */}
                <form>
                  <div className="row">
                    <div id="sign-in-button"></div>
                    <div className="login-header ml-3">
                      <h4>Sign in</h4>
                      <p>{this.state.errorMessage}</p>
                    </div>
                    <div className="col-lg-12">
                      <Input
                        title="Email Address*"
                        type="email"
                        className="form-control custom-input"
                        placeholder="Email Address*"
                        name="email"
                        value={email}
                        onChange={this.handleChange}
                      />
                      <span className="error-message-text">
                        {this.state.errorValidateMessage?.['email']}
                      </span>
                    </div>
                    <div className="col-lg-12">
                      <Input
                        title="Password*"
                        type={showPassword ? 'text' : 'password'}
                        className="form-control custom-input"
                        placeholder="Password*"
                        name="password"
                        value={password}
                        onChange={this.handleChange}
                      >
                        <p
                          onClick={this.showHidePassword.bind(
                            this,
                            'showPassword'
                          )}
                        >
                          <img
                            alt="eye"
                            src="/assets/img/eye.png"
                            className="img img-fluid eye"
                          />
                        </p>
                      </Input>
                      <span className="error-message-text">
                        {this.state.errorValidateMessage?.['password']}
                      </span>
                    </div>
                    {/* {!this.props.isAdminAuthRoute ? ( */}
                    <div className="col-lg-12">
                      <span
                        className="forgot-pass"
                        onClick={() => {
                          this.setState({ resetPasswordModal: true });
                        }}
                      >
                        Forgot Password?
                      </span>
                    </div>
                    {/* ) : null} */}
                    <div className="col-lg-12">
                      <div className="input-div">
                        <button className="log-btn" onClick={this.submitForm}>
                          Log In
                          {/* { this.state.isLoading ? <Spinner variant='primary' animation='border' /> : null } */}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                {/* {!this.props.isAdminAuthRoute ? (
                  <p className="dnthaveacc verification-link header-part-pd">
                    <span
                      className="forgot-pass verfication-email"
                      onClick={() => {
                        this.setState({ resendLink: true });
                      }}
                    >
                      Send Verification Link
                    </span>
                  </p>
                ) : null} */}
              </div>
            </>
          )}
          {!this.props.isAdminAuthRoute ? (
            <p className="dnthaveacc header-part-pd">
              Don’t already have an account?{' '}
              <Link to="/signup">Register now!</Link>
            </p>
          ) : null}
        </div>
        <img
          src={
            this.props.isAdminAuthRoute
              ? '/assets/img/admin_login.svg'
              : '/assets/img/big_img.png'
          }
          alt="big_img"
          className={`img img-fluid ${this.props.isAdminAuthRoute ? 'admin-big-bg' : 'big-bg'
            }`}
        />
        {subscriptionPlanModal ? (
            <SubscriptionPlan
              hidePopup={() => {
                window.location.reload();
                this.props.history.push(
                  this.props.isAdminAuthRoute
                    ? '/admin/dashboard'
                    : '/dashboard'
                );
              }}
              isNextButton={true}
              showButtonAction={() => {
                 window.location.reload();
                  this.props.history.push(
                    this.props.isAdminAuthRoute
                      ? '/admin/dashboard'
                      : '/dashboard'
                  );
              }}
            />
        ) : (
            ''
        )}
        {/* {resetPasswordModal && !resetStep2 ? ( */}
        <div
          className={`common-popup reset-password popup-common-class fade ${resetPasswordModal && !resetStep2 ? 'show' : ''
            }`}
        >
          <div className="common-popup-outer">
            <div className="common-popup-inner">
              <div className="common-popup-box animate-box">
                <div className="common-popup-head">
                  <h2>Reset Password</h2>
                  <div
                    className="common-pop-close"
                    onClick={() => {
                      this.setState({
                        resetPasswordModal: false,
                        forgotEmail: '',
                      });
                    }}
                  >
                    <img src="/assets/img/exit.png" alt="exit" />
                  </div>
                  <div className="step-progress">
                    <div className="step-p-text">
                      <span>Step 1 of 2</span>
                    </div>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{ width: '50%' }}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="common-popup-innersec">
                  <div className="common-popup-head">
                    <h2>Reset Password</h2>
                    <div
                      className="common-pop-close"
                      onClick={() => {
                        this.setState({
                          resetPasswordModal: false,
                          resetStep2: false,
                          forgotEmail: '',
                        });
                      }}
                    >
                      <img src="/assets/img/exit.png" alt="exit" />
                    </div>
                  </div>
                  <div className="reset-password-form">
                    <div className="reset-email-sec">
                      <p>
                        Please enter your registered email address to receive a
                        password reset link.
                      </p>
                      <div className="reset-form">
                        <div className="form-group">
                          <label>Email Address</label>
                          <input
                            type="email"
                            name="forgotEmail"
                            value={forgotEmail}
                            onChange={this.handleChange}
                            className="form-control"
                          />
                          <span className="error-message-text">
                            {this.state.errorValidateMessage?.['forgotEmail']}
                          </span>
                        </div>
                        <div className="form-group">
                          <button
                            className="log-btn step-btn reset-step2"
                            onClick={this.sendResetMail}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ) : (
          ""
        )} */}
        {/* {resetPasswordModal && resetStep2 ? ( */}
        <div
          className={`common-popup reset-password fade ${resetPasswordModal && resetStep2 ? 'show' : ''
            }`}
        >
          <div className="common-popup-outer">
            <div className="common-popup-inner">
              <div className="common-popup-box animate-box">
                <div className="common-popup-head">
                  <h2>Reset Password</h2>
                  <div
                    className="common-pop-close"
                    onClick={() => {
                      this.setState({
                        resetPasswordModal: false,
                        resetStep2: false,
                        forgotEmail: '',
                      });
                    }}
                  >
                    <img src="/assets/img/exit.png" alt="exit" />
                  </div>
                  <div className="step-progress">
                    <div className="step-p-text">
                      <h4>{null}</h4>
                      <span>Step 2 of 2</span>
                    </div>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{ width: '100%' }}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="common-popup-innersec">
                  <div className="reset-password-form">
                    <div className="reset-email-sec">
                      <div className="step-p-text">
                        <h4>Mail Successfully sent</h4>
                      </div>
                      <div className="success-patient-inner">
                        <img src="/assets/img/tick.png" alt="tick" />
                        <p>
                          If the account exists, then we will send a reset
                          password link to {forgotEmail}. Please check your
                          email, and click on the given link to reset your
                          password.
                        </p>
                        <button
                          className="log-btn step-btn reset-step2"
                          onClick={() => {
                            this.setState({
                              resetPasswordModal: false,
                              resetStep2: false,
                              forgotEmail: '',
                              password: '',
                            });
                          }}
                        >
                          Login
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ) : (
          ""
        )} */}
        {/* {planModal ? ( */}
        <div
          className={`step-wrapper common-pop resetpass-success-pop popup-common-class fade ${planModal ? 'show' : ''
            }`}
        >
          <div className="patient-pop-outer">
            <div className="patient-pop-box animate-box">
              <div className="step-outter">
                <div className="three-steps">
                  <div className="step-top">
                    <div className="step-progress">
                      <div className="step-p-text">
                        <h4>Plan downgraded</h4>
                      </div>
                      <div className="success-patient-inner">
                        <img src="/assets/img/tick.png" alt="tick" />
                        <p>You're all set! </p>
                        <p>
                          Sign in with your new password to access your account
                        </p>
                        <button className="log-btn step-btn reset-done">
                          Sign In
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ) : (
          ""
        )} */}
        {/* {resendCodeModal ? ( */}
        <div
          className={`step-wrapper common-pop resend-code-pop popup-common-class fade ${resendCodeModal ? 'show' : ''
            }`}
        >
          <div className="patient-pop-outer">
            <div className="patient-pop-box animate-box">
              <div className="step-outter">
                <div className="three-steps">
                  <div className="step-top">
                    <div className="step-progress">
                      <div className="step-p-text">
                        <h4>Reset Code</h4>
                        <div className="pop-close-cross">
                          <img src="/assets/img/exit.png" alt="exit" />
                        </div>
                      </div>
                      <div className="resend-code-inner">
                        <img
                          src="/assets/img/resend-code.jpg"
                          alt="resend_code"
                        />
                        <button className="log-btn step-btn resend-code-btn">
                          Resend Code
                        </button>
                        <div className="or-sec">
                          <span>OR</span>
                        </div>
                        <button className="log-btn step-btn blue-transparent">
                          Contact Support
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ) : (
          ""
        )} */}

        {/* verification mail model */}
      </div>
    );
  }
}

export default Login;
